<template>
  <v-menu offset-y :close-on-content-click="false" :max-width="maxWidth">
    <template v-slot:activator="{ on }">
      <v-btn :icon="iconOnly" :small="small" v-on="on" :color="value.length > 0 ? 'primary' : ''">
        <v-badge :content="value.length" :value="value.length > 0" color="primary" overlap>
          <v-icon :small="small">mdi-tag-multiple</v-icon>
        </v-badge>
        <span v-if="!iconOnly" class="ml-1">{{ $t("tags.filter_by_tags") }}</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-text class="pa-3">
        <div v-if="loading" class="text-center py-3">
          <v-progress-circular indeterminate size="20" color="primary" />
        </div>
        <template v-else>
          <div v-for="group in tagGroups" :key="group.id" class="mb-2">
            <div class="caption grey--text">{{ groupDisplayName(group) }}</div>
            <v-chip-group :value="selectionByGroup[group.id]" column multiple
                          @change="onGroupChange(group.id, $event)">
              <v-chip v-for="tag in group.tags" :key="tag.id" :value="tag.id"
                      small filter outlined :color="tag.color">
                {{ tag.name }}
              </v-chip>
            </v-chip-group>
          </div>
          <div v-if="tagGroups.length === 0" class="caption grey--text">{{ $t("tags.no_groups") }}</div>
          <v-btn v-if="value.length > 0" x-small text block class="mt-1" @click="clear">
            {{ $t("custom.reset") }}
          </v-btn>
        </template>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "TagFilter",
  model: { prop: "value", event: "input" },
  props: {
    value: { type: Array, default: () => [] },
    taggableType: { type: String, default: "Car" },
    externalGroups: { type: Array, default: null },
    iconOnly: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
    maxWidth: { type: [String, Number], default: 320 },
  },
  data() {
    return {
      tagGroups: [],
      loading: false,
      selectionByGroup: {},
    };
  },
  computed: {
    authToken() {
      return this.$store.getters.getAuthToken;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.rebuildSelectionFromValue();
      },
    },
    externalGroups: {
      immediate: true,
      handler(groups) {
        if (groups) {
          this.tagGroups = groups;
          this.rebuildSelectionFromValue();
        }
      },
    },
  },
  mounted() {
    if (!this.externalGroups) {
      this.loadTagGroups();
    }
  },
  methods: {
    groupDisplayName(group) {
      if (group.system) {
        const key = "tags.system_" + group.name;
        const translated = this.$t(key);
        return translated !== key ? translated : group.name;
      }
      return group.name;
    },
    loadTagGroups() {
      this.loading = true;
      this.axios
        .get("/api/v1/tag_groups", {
          headers: { Authorization: this.authToken },
          params: { taggable_type: this.taggableType },
        })
        .then((response) => {
          const data = response.data.data || [];
          this.tagGroups = data.map((item) => {
            const attrs = item.attributes || {};
            const includedTags = (response.data.included || [])
              .filter((inc) => inc.type === "tag" && item.relationships && item.relationships.tags &&
                item.relationships.tags.data.some((r) => r.id === inc.id))
              .map((inc) => ({ id: parseInt(inc.id), ...inc.attributes }))
              .sort((a, b) => a.sort_order - b.sort_order);
            return { id: parseInt(item.id), ...attrs, tags: includedTags };
          });
          this.rebuildSelectionFromValue();
        })
        .catch(() => {})
        .finally(() => { this.loading = false; });
    },
    rebuildSelectionFromValue() {
      const sel = {};
      this.tagGroups.forEach((g) => {
        sel[g.id] = g.tags.filter((t) => this.value.includes(t.id)).map((t) => t.id);
      });
      this.selectionByGroup = sel;
    },
    onGroupChange(groupId, ids) {
      this.$set(this.selectionByGroup, groupId, ids || []);
      const all = [];
      Object.values(this.selectionByGroup).forEach((arr) => {
        if (Array.isArray(arr)) arr.forEach((id) => all.push(id));
      });
      this.$emit("input", all);
    },
    clear() {
      const sel = {};
      this.tagGroups.forEach((g) => { sel[g.id] = []; });
      this.$set(this, "selectionByGroup", sel);
      this.$emit("input", []);
    },
  },
};
</script>
